/**
 * Get the current pathname and any search params
 * @returns Current app url
 */
export const getCurrentAppUrl = (): string =>
  `${globalThis.location.pathname}${globalThis.location.search}`
